import { Component, inject, input, output } from '@angular/core';
import { HudIconButtonComponent } from '@features/hud/hud-icon-button/hud-icon-button.component';
import { LpInventoryItemContentComponent } from '@features/lp/lp-inventory/lp-inventory-item-content/lp-inventory-item-content.component';
import { StyleSheetSpriteComponent } from '@features/styles/style-sheet-sprite/style-sheet-sprite.component';
import { StylesService } from '@features/styles/styles.service';
import { LpItem } from '@typings/lp/generated';

@Component({
  selector: 'lp-inventory-item-modal',
  imports: [StyleSheetSpriteComponent, LpInventoryItemContentComponent, HudIconButtonComponent],
  templateUrl: './lp-inventory-item-modal.component.html',
  styleUrl: './lp-inventory-item-modal.component.css',
})
export class LpInventoryItemModalComponent {
  readonly _stylesService = inject(StylesService);

  item = input.required<LpItem>();

  closed = output<void>();
}
